import { render, staticRenderFns } from "./ParentLayout.vue?vue&type=template&id=ed2ec53e&scoped=true&"
import script from "./ParentLayout.vue?vue&type=script&lang=js&"
export * from "./ParentLayout.vue?vue&type=script&lang=js&"
import style0 from "./ParentLayout.vue?vue&type=style&index=0&id=ed2ec53e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2ec53e",
  null
  
)

export default component.exports